import * as yup from "yup";
import { BarcodePrefixes } from "../../../constants/BarcodePrefixes";

const AcademicLicenceFormValidation = yup.object().shape({
	tcNo: yup
		.string()
		.matches(/^\d*$/, {
			excludeEmptyString: true,
			message: "T.C. Kimlik Numarası sadece rakamlardan oluşmalıdır.",
		})
		.length(11, "T.C. Kimlik Numarası 11 haneli olmalıdır.")
		.required("Zorunlu alan."),
	barcode: yup
		.string()
		.required("Zorunlu alan.")
		.when("licenceType", {
			is: "student",
			then: yup.string().test({
				name: "isStudent",
				test: (value) => {
					return value?.startsWith(BarcodePrefixes.STUDENT) ? true : false;
				},
				message: "Barkod numarası geçerli değil.",
			}),
			otherwise: yup.string().test({
				name: "isAcademician",
				test: (value) => {
					return value?.startsWith(BarcodePrefixes.ACADEMICIAN)
						? true
						: false;
				},
				message: "Barkod numarası geçerli değil.",
			}),
		}),
});

export default AcademicLicenceFormValidation;
